import React from 'react';
import { FadeIn } from './FadeIn';
export function SolutionSection() {
  const benefits = [{
    icon: '✨',
    title: 'Citas Listas',
    description: 'Elegís, compartís y disfrutás. Sin vueltas ni planificaciones estresantes.'
  }, {
    icon: '🌱',
    title: 'Vínculos Fuertes',
    description: 'Actividades diseñadas por expertos para fortalecer la confianza y el diálogo.'
  }, {
    icon: '📵',
    title: 'Digital Detox',
    description: 'La excusa perfecta para soltar el celular, apagar la tele y mirarse a los ojos.'
  }, {
    icon: '💰',
    title: 'Económico',
    description: 'Desafíos simples y creativos que no requieren grandes gastos ni materiales raros.'
  }];
  return <section className="py-10 bg-brand-50" data-id="element-116">
      <div className="container mx-auto px-4" data-id="element-117">
        <FadeIn data-id="element-118">
          <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-119">
            <span className="text-brand-600 font-bold tracking-wider uppercase text-sm mb-1 block" data-id="element-120">
              La Solución Definitiva
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-3" data-id="element-121">
              Presentamos el PACK 100 CITAS: Tu mapa de conexión familiar. 📚
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-5xl mx-auto" data-id="element-122">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-123">
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-brand-100 hover:shadow-md transition-shadow h-full" data-id="element-124">
                <div className="text-4xl mb-3 bg-brand-50 w-16 h-16 rounded-xl flex items-center justify-center" data-id="element-125">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-126">
                  {benefit.title}
                </h3>
                <p className="text-slate-600 text-base leading-relaxed" data-id="element-127">
                  {benefit.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}